import store from 'store2';
import { KEY_UTM_LABELS } from '~/constants';
import { getFromLocalStorage, saveToLocalStorage } from '~/helpers/storage';
import { parseGetParams } from '~/utils/parseGetParamsResult';

// const utmTimeout = 1000 * 60 * 60 * 24; // сутки
const utmTimeout = 1000 * 60; // минута (для теста)

export type TUtmLabels = 'utmFromEmail';

const utmLabels: TUtmLabels[] = ['utmFromEmail'];

type UTMLabelsType = { [key: string]: string };

export const refreshUtmLabels = () => {
  const realUtmLabels = parseGetParams({ params: utmLabels });
  const savedUtmLabels = store(KEY_UTM_LABELS);

  realUtmLabels &&
    Object.keys(realUtmLabels).forEach((utmLabelKey) => {
      const savedUtm = getFromLocalStorage<UTMLabelsType>(
        KEY_UTM_LABELS,
        utmLabelKey
      );

      const isNeedToSave =
        (savedUtm && Date.now() - parseInt(savedUtm.time, 10) > utmTimeout) ||
        !savedUtm;

      if (isNeedToSave) {
        const utmDataToSave = {
          value: realUtmLabels[utmLabelKey],
          time: Date.now(),
        };
        saveToLocalStorage(KEY_UTM_LABELS, utmLabelKey, utmDataToSave);
      }
    });
};

export const getUtmEmailLabel = () => {
  return getFromLocalStorage<{ [key: string]: string }>(KEY_UTM_LABELS, 'utmFromEmail')?.value;
};
